/**
 * @description Client-side helpers for the server-injected brand logo map.
 *
 * `server/services/brandLogos.ts` writes
 * `<script>window.__BRAND_LOGOS = {...}</script>` into the HTML shell on every
 * request from the live `product_brands` rows. Reading that map synchronously
 * (no React Query round-trip) lets the Header, Footer, and any other branded
 * surface render the current admin-uploaded logo on the very first paint —
 * even on a cold-cache visit, with no flash of a stale or default asset.
 *
 * @module lib/brandLogos
 */

export type InjectedBrandLogos = Record<string, string>;

export function getInjectedBrandLogos(): InjectedBrandLogos {
  if (typeof window === "undefined") return {};
  const injected = (window as unknown as { __BRAND_LOGOS?: InjectedBrandLogos })
    .__BRAND_LOGOS;
  return injected && typeof injected === "object" ? injected : {};
}

export function getInjectedBrandLogo(productKey: string): string | undefined {
  const map = getInjectedBrandLogos();
  return map[productKey];
}
